import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import _ from 'lodash'
import startOfWeek from 'date-fns/start_of_week';
import endOfWeek from 'date-fns/end_of_week';
import startOfMonth from 'date-fns/start_of_month';
import endOfMonth from 'date-fns/end_of_month';
import addDays from 'date-fns/add_days';
import subMonths from "date-fns/sub_months";
import addMonths from 'date-fns/add_months';
import { getUserAll } from './core/cacheService';
export default {
    namespaced: true,
    state: {
        houses:[],
        housesfilter:[],
        runningtrack_day:[],
        runningtrack_day_all:[],
        runningtrack_month:[],
        runningtrack_month_all:[],
        runningtrack_last_month:[],
        runningtrack_last_month_all:[],
        runningtrack_week:[],
        runningtrack_week_all:[],
        runningtrack_graphmonth:[],
        runningtrack_graphmonth16:[],
        distance_all:0,
        distance_all16:0,
        members:[],
        users:[],
        allusers:[],
        membersDelphinus:[],
        membersLeonos:[],
        membersCorvus:[],
        activeUsers:[],
        mission:[]
    },
    mutations: {
        setHouses(state:any, result:any) {
            state.houses = result
        },
        setHousesFilter(state:any, result:any) {
            state.housesfilter = result
        },
        setRunningTrackToday(state:any, result:any){
            state.runningtrack_day = result
        },
        setRunningTrackTodayAll(state:any, result:any){
            state.runningtrack_day_all = result
        },
        setRunningTrackWeek(state:any, result:any){
            state.runningtrack_week = result
        },
        setRunningTrackWeekAll(state:any, result:any){
            state.runningtrack_week_all = result
        },
        setRunningTrackMonth(state:any, result:any){
            state.runningtrack_month = result
        },
        setRunningTrackMonthAll(state:any, result:any){
            state.runningtrack_month_all = result
        },
        setRunningTrackLastMonth(state:any, result:any){
            state.runningtrack_last_month = result
        },
        setRunningTrackLastMonthAll(state:any, result:any){
            state.runningtrack_last_month_all = result
        },
        setRunningTrackGraphMonth(state:any, result:any){
            state.runningtrack_graphmonth = result
        },
        setRunningTrackGraphMonth16(state:any, result:any){
            state.runningtrack_graphmonth16 = result
        },
        setAllDistance(state:any, result:number){
            state.distance_all = result
        },
        setAllDistance16(state:any, result:number){
            state.distance_all16 = result
        },
        setMembers(state:any, members:any){
            state.members = members
        },
        setAllUsers(state:any, allusers:any){
            state.allusers = allusers
        },
        setMembersDelphinus(state:any, allusers:any){
            state.membersDelphinus = allusers
        },
        setMembersLeonos(state:any, allusers:any){
            state.membersLeonos = allusers
        },
        setMembersCorvus(state:any, allusers:any){
            state.membersCorvus = allusers
        },
        setActiveUsers(state:any, activeUsers:any){
            state.activeUsers = activeUsers
        },
        setMissionUsers(state:any, mission:any){
            state.mission = mission
        }
    },
    actions: {
        async getDataHouseMember({ state, commit, dispatch, rootState }: any, houseId:string){
            if(state.users.length == 0) {
                const allUser = await getUserAll(rootState.authen.user.company)//rootState.main.allUser// (await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
                commit('setAllUsers', allUser)
            }
            let members = [];
            if(houseId === '-LWOr-XsbZM2digYl1QL' && state.membersDelphinus){
                members = state.membersDelphinus;
            }else if(houseId === '-LWPrOElCYViBd6j6qP-' && state.membersLeonos){
                members = state.membersLeonos;
            }else if(houseId === '-LWPrZbcyHAVHIFUsWLd' && state.membersCorvus){
                members = state.membersCorvus;
            }
            if(members.length){
                const members: Array<any> = [];
                for(const x in members){
                    const member: any = members[x];
                    member.key = member.email;
                    const emailKey = member.email.replace(/\./g, '||');
                    if(state.allusers[emailKey]){
                        member.image = state.allusers[emailKey].profilepic_crop
                        members.push(member)
                    }
                }
                commit('setMembers', members)
            }else{
                firebase.firestore().collection(`houses/${houseId}/members`).orderBy('firstname').get()
                .then(function (querySnapshot) {
                const members: Array<any> = [];
                querySnapshot.forEach((doc) => {
                    const member = doc.data()
                    member.key = doc.id
                    const emailKey = doc.data().email.replace(/\./g, '||');
                    if(state.allusers[emailKey]){
                        member.image = state.allusers[emailKey].profilepic_crop
                        members.push(member)
                    }
                });
                    commit('setMembers', members)
                });
            }
        },
        async getDataHouse({ state,commit, dispatch, rootState }: any){
            firebase.firestore().collection('houses').where("company", "==", rootState.authen.user.company).get()
              .then(function (querySnapshot) {
                const houses: Array<any> = [];
                querySnapshot.forEach((doc) => {
                  const house = doc.data()
                  house.key = doc.id
                  house.population = 0
                  houses.push(house)
                });
                let all:number = 0;
                for(const x in houses){
                    all += houses[x].members;
                }
                if(all) {
                    for(const x in houses){
                        houses[x].population = (houses[x].members/all)*100;
                    }
                }
                commit('setHouses', houses)
                dispatch('getDataHouseFilter','THIS WEEK')
            });
        },
        async getDataHouseFilter({ commit, state,dispatch, rootState }: any,filter:string){
            if(state.users.length == 0) {
                const allUser =  await getUserAll(rootState.authen.user.company)//rootState.main.allUser//(await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
                commit('setAllUsers', allUser)
            }
            const dateNow = new Date()
            const {houses} = state;
            let startdate = '';
            let enddate = '';
            if(filter === 'THIS WEEK') {
                startdate = format(startOfWeek(dateNow,{weekStartsOn:1}), 'YYYY-MM-DD')
                enddate = format(dateNow, 'YYYY-MM-DD')
            }else if(filter === 'THIS MONTH') {
                startdate = format(startOfMonth(dateNow), 'YYYY-MM')
                enddate = format(dateNow, 'YYYY-MM-DD')
            }else if(filter === 'LAST WEEK') {
                startdate = format(startOfWeek(addDays(dateNow, -7),{weekStartsOn:1}), 'YYYY-MM-DD')
                enddate = format(endOfWeek(addDays(dateNow, -7),{weekStartsOn:1}), 'YYYY-MM-DD')
            }else if(filter === 'LAST MONTH') {
                startdate = format(startOfMonth(addMonths(dateNow, -1)), 'YYYY-MM')
                enddate = format(endOfMonth(addMonths(dateNow, -1)), 'YYYY-MM-DD')
            }else{//ALL-TIME
                startdate = '0000-00-00';
                enddate = format(dateNow, 'YYYY-MM-DD');
            }
            await dispatch('getMisiionUser',filter)
            const members:Array<any> = [];
            const activeUser:any = [];
            const usersAll = state.allusers
            const activeUsers:Array<any> = [];
            if(filter === 'LAST WEEK' || filter === 'LAST MONTH'){
                await firebase.firestore().collection('active_users_day').where('company','==',rootState.authen.user.company).where('date','>=',startdate).where('date','<=',enddate).get().then(function (querySnapshot) {
                    querySnapshot.forEach((doc) => {
                        activeUsers[doc.data().email] = doc.data().email;
                    });
                });
            }
            for(const x in houses) {
               
                if(members[houses[x].key] === undefined) {
                    members[houses[x].key] = {
                        members:0,
                        xp:0,
                        distance:0,
                    };
                }
                await firebase.firestore().collection(`houses/${houses[x].key}/activities`).where('date', '>=', startdate).where('date', '<=', enddate).get().then(function (querySnapshot) {
                    querySnapshot.forEach((doc) => {
                        if(doc.data().code !== undefined && doc.data().code === 'nr') {
                            if(filter === 'ALL-TIME') {
                                members[houses[x].key].members = houses[x].members;
                            }else{
                                members[houses[x].key].members += doc.data().members;
                            }
                        }
                        members[houses[x].key].xp += doc.data().xp;
                    });
                });
                const membersHouse:Array<any> = [];
                await firebase.firestore().collection(`houses/${houses[x].key}/members`).get().then(function (querySnapshot) {
                    querySnapshot.forEach((doc) => {
                        const data = doc.data();
                        membersHouse.push(data);
                        if(activeUser[houses[x].key] === undefined){
                            activeUser[houses[x].key] = 0;
                        }
                        const emailKey = data.email.replace(/\./g, '||');
                        if(filter === 'LAST WEEK' || filter === 'LAST MONTH'){
                            if(activeUsers[data.email]){
                                activeUser[houses[x].key]++;
                            }
                        }else if(usersAll[emailKey]){
                            const updatetime = (usersAll[emailKey].updated)?usersAll[emailKey].updated:'';
                            if(updatetime){
                                const checktime = updatetime.toString().split(' ');
                                if(checktime[0] && checktime[0] >= startdate && checktime[0]<=enddate){
                                    activeUser[houses[x].key]++;
                                }
                            }
                        }
                    });
                    if(houses[x].key === '-LWOr-XsbZM2digYl1QL') {
                        commit('setMembersDelphinus',membersHouse);
                    }else if(houses[x].key === '-LWPrOElCYViBd6j6qP-'){
                        commit('setMembersLeonos',membersHouse);
                    }else{
                        commit('setMembersCorvus',membersHouse);
                    }
                });
            }
           
            commit('setActiveUsers',activeUser);
            if(filter === 'THIS WEEK' || filter === 'LAST WEEK') {
                await firebase.firestore().collection('running_track_day').where('company','==',rootState.authen.user.company).where('date', '>=', startdate).where('date', '<=', enddate).get().then(function (querySnapshot) {
                    members[`${rootState.authen.user.company}-`] = {
                        members:0,
                        xp:0,
                    };
                    querySnapshot.forEach((doc) => {
                        /*'#1d97f2'='-LWOr-XsbZM2digYl1QL'
                        '#ffbf1f'='-LWPrOElCYViBd6j6qP-'
                        '#ea183c'='-LWPrZbcyHAVHIFUsWLd'*/
                        if(doc.data().distance !== undefined && doc.data().distance>0) {
                            if(doc.data().color === '#1d97f2') {
                                members[`${rootState.authen.user.company}-LWOr-XsbZM2digYl1QL`].distance += doc.data().distance;
                            }else if(doc.data().color === '#ffbf1f') {
                                members[`${rootState.authen.user.company}-LWPrOElCYViBd6j6qP-`].distance += doc.data().distance;
                            }else if(doc.data().color === '#ea183c') {
                                members[`${rootState.authen.user.company}-LWPrZbcyHAVHIFUsWLd`].distance += doc.data().distance;
                            }
                        }
                    });
                }); 
            }else if(filter === 'THIS MONTH' || filter === 'LAST MONTH'){
                await firebase.firestore().collection('running_track_month_house').where('company','==',rootState.authen.user.company).where('date', '==', startdate).get().then(function (querySnapshot) {
                    members[`${rootState.authen.user.company}-`] = {
                        members:0,
                        xp:0,
                    };
                    querySnapshot.forEach((doc) => {
                        /*'#1d97f2'='-LWOr-XsbZM2digYl1QL'
                        '#ffbf1f'='-LWPrOElCYViBd6j6qP-'
                        '#ea183c'='-LWPrZbcyHAVHIFUsWLd'*/
                        if(doc.data().distance !== undefined && doc.data().distance>0) {
                            if(doc.data().color === '#1d97f2') {
                                members[`${rootState.authen.user.company}-LWOr-XsbZM2digYl1QL`].distance += doc.data().distance;
                            }else if(doc.data().color === '#ffbf1f') {
                                members[`${rootState.authen.user.company}-LWPrOElCYViBd6j6qP-`].distance += doc.data().distance;
                            }else if(doc.data().color === '#ea183c') {
                                members[`${rootState.authen.user.company}-LWPrZbcyHAVHIFUsWLd`].distance += doc.data().distance;
                            }
                        }
                    });
                }); 
            }else if(filter === 'ALL-TIME'){
                await firebase.firestore().collection('running_track_month_house').where('company','==',rootState.authen.user.company).get().then(function (querySnapshot) {
                    members[`${rootState.authen.user.company}-`] = {
                        members:0,
                        xp:0,
                    };
                    querySnapshot.forEach((doc) => {
                        /*'#1d97f2'='-LWOr-XsbZM2digYl1QL'
                        '#ffbf1f'='-LWPrOElCYViBd6j6qP-'
                        '#ea183c'='-LWPrZbcyHAVHIFUsWLd'*/
                        if(doc.data().distance !== undefined && doc.data().distance>0) {
                            if(doc.data().color === '#1d97f2') {
                                members[`${rootState.authen.user.company}-LWOr-XsbZM2digYl1QL`].distance += doc.data().distance;
                            }else if(doc.data().color === '#ffbf1f') {
                                members[`${rootState.authen.user.company}-LWPrOElCYViBd6j6qP-`].distance += doc.data().distance;
                            }else if(doc.data().color === '#ea183c') {
                                members[`${rootState.authen.user.company}-LWPrZbcyHAVHIFUsWLd`].distance += doc.data().distance;
                            }
                        }
                    });
                }); 
            }
            const results:Array<any> = [];
            let sort_members = Object.keys(members).sort(function(a,b){return members[b].xp - members[a].xp})
            _.forEach(sort_members, (value,key)=> {
                const index = _.findIndex(state.houses, (el:any) => {
                    return el.key === value;
                });
                if(index !== -1){
                    results.push(state.houses[index])
                }
              });
            commit('setHouses',results)
            commit('setHousesFilter', members)
        },
        async getMisiionUser({ state,commit, dispatch, rootState }: any,filter:any){
            const filter_date:  Array<any> = [];
            const dateNow = new Date()
            let startdate = '';
            let enddate = '';
            if(filter === 'THIS WEEK') {
                startdate = format(startOfWeek(dateNow,{weekStartsOn:1}), 'YYYY-MM-DD')
                for(var i=0;i<7;i++){
                    const _date = format(addDays(startdate, i), 'YYYY-MM-DD')
                   filter_date.push({date:_date})
                }
 
            }else if(filter === 'THIS MONTH') {
                startdate = format(startOfMonth(dateNow), 'YYYY-MM')
                enddate = format(dateNow, 'YYYY-MM-DD')
            }else if(filter === 'LAST WEEK') {
                startdate = format(startOfWeek(addDays(dateNow, -7),{weekStartsOn:1}), 'YYYY-MM-DD')
                for(var i=0;i<7;i++){
                    const _date = format(addDays(startdate, i), 'YYYY-MM-DD')
                   filter_date.push({date:_date})
                }
                // startdate = format(startOfWeek(addDays(dateNow, -7),{weekStartsOn:1}), 'YYYY-MM-DD')
                // enddate = format(endOfWeek(addDays(dateNow, -7),{weekStartsOn:1}), 'YYYY-MM-DD')
            }else if(filter === 'LAST MONTH') {
                startdate = format(startOfMonth(addMonths(dateNow, -1)), 'YYYY-MM')
                enddate = format(endOfMonth(addMonths(dateNow, -1)), 'YYYY-MM-DD')
            }else{//ALL-TIME
                startdate = '0000-00-00';
                enddate = format(dateNow, 'YYYY-MM-DD');
            }
            const missionUser:  Array<any> = [];
            await  firebase.firestore().collection('mission_users').where("company","==",rootState.authen.user.company).get()
            .then(function (querySnapshot) {
              querySnapshot.forEach((doc) => {
                const data = doc.data();
                const key=data.company+data.house
                const create_date = format(doc.data().create_date, 'YYYY-MM')
                if(filter === 'THIS WEEK') {
                    const create_date = format(doc.data().create_date, 'YYYY-MM-DD')
                    let _date = _.find(filter_date, function(value){
                        return value != null && value.date == create_date;
                      });
                   
                    if(_date){
                        if(!missionUser[key]){
                            missionUser[key]={entry:1,participation:data.vote}
                        }else {
                            missionUser[key].entry++
                            missionUser[key].participation=missionUser[key].participation+data.vote
                        }
                    }
                    
                }else if(filter === 'THIS MONTH') {
                    if(create_date===startdate){
                        if(!missionUser[key]){
                            missionUser[key]={entry:1,participation:data.vote}
                        }else {
                            missionUser[key].entry++
                            missionUser[key].participation=missionUser[key].participation+data.vote
                        }
                    }

                }else if(filter === 'LAST WEEK') {
                    const create_date = format(doc.data().create_date, 'YYYY-MM-DD')
                   
                    let _date = _.find(filter_date, function(value){
                        return value != null && value.date == create_date;
                      });
                   
                    if(_date){
                        if(!missionUser[key]){
                            missionUser[key]={entry:1,participation:data.vote}
                        }else {
                            missionUser[key].entry++
                            missionUser[key].participation=missionUser[key].participation+data.vote
                        }
                    }
                    

                }else if(filter === 'LAST MONTH') {
                    if(create_date===startdate){
                        if(!missionUser[key]){
                            missionUser[key]={entry:1,participation:data.vote}
                        }else {
                            missionUser[key].entry++
                            missionUser[key].participation=missionUser[key].participation+data.vote
                        }
                    }
                }else{
                    if(!missionUser[key]){
                        missionUser[key]={entry:1,participation:data.vote}
                    }else {
                        missionUser[key].entry++
                        missionUser[key].participation=missionUser[key].participation+data.vote
                    }
                }
                });
              commit('setMissionUsers', missionUser)
              });
          },
        getDataRunningTrack({ commit, rootState }: any){
            const dateNow = new Date()
            const today = format(dateNow, 'YYYY-MM-DD')
            const month = format(dateNow, 'YYYY-MM')
            const last_month = format(subMonths(dateNow, 1), "YYYY-MM")
            const months: Array<any> = [];
            const months16: Array<any> = [];
            const yearnow = format(dateNow, 'YYYY')
            //const runingtrack_by_month: Array<any> = [];
            for(let x=0; x<6; x++){
                const enddate = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY-MM')
                const year = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY')
                if(yearnow !== year){
                    months[enddate] = {
                        month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM ‘YY'),
                        value:0
                    }
                }else{
                    months[enddate] = { 
                        month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM'),
                        value:0
                    }
                }
            }
            for(let x=0; x<16; x++){
                const enddate = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY-MM')
                const year = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY')
                if(yearnow !== year){
                    months16[enddate] = {
                        month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM ‘YY'),
                        value:0
                    }
                }else{
                    months16[enddate] = { 
                        month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM'),
                        value:0
                    }
                }
            }
            firebase.firestore().collection('running_track_day').where("company", "==", rootState.authen.user.company).where('date','==',today).orderBy('distance','desc').get().then(function (querySnapshot) {
                const runningtrack_day: Array<any> = [];
                const runningtrack_day_all: Array<any> = [];
                let i = 0;
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    data.key = doc.id;
                    if(i<10)
                    runningtrack_day.push(data)
                    runningtrack_day_all.push(data)
                    i++;
                });
                commit('setRunningTrackToday', runningtrack_day)
                commit('setRunningTrackTodayAll', runningtrack_day_all)
            });
            firebase.firestore().collection('running_track_week').where("company", "==", rootState.authen.user.company).orderBy('distance','desc').get().then(function (querySnapshot) {
                const runningtrack_week: Array<any> = [];
                const runningtrack_week_all: Array<any> = [];
                let i = 0;
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    data.key = doc.id;
                    if(i<10)
                    runningtrack_week.push(data)
                    runningtrack_week_all.push(data)
                    i++;
                });
                commit('setRunningTrackWeek', runningtrack_week)
                commit('setRunningTrackWeekAll', runningtrack_week_all)
                
            });
            firebase.firestore().collection('running_track_month').where("company", "==", rootState.authen.user.company).where('date','in',[month,last_month]).orderBy('distance','desc').get().then(function (querySnapshot) {
                const runningtrack_month: Array<any> = [];
                const runningtrack_month_all: Array<any> = [];
                const runningtrack_last_month: Array<any> = [];
                const runningtrack_last_month_all: Array<any> = [];
                let i = 0;
                let i1 = 0;
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    data.key = doc.id;
                    if(data.date==month){
                        if(i<10)
                            runningtrack_month.push(data)
                            runningtrack_month_all.push(data)
                            i++;

                    }else{
                        if(i1<10)
                            runningtrack_last_month.push(data)
                            runningtrack_last_month_all.push(data)
                            i1++;
                    }
                   
                });
                
                commit('setRunningTrackMonth', runningtrack_month)
                commit('setRunningTrackMonthAll', runningtrack_month_all)
                commit('setRunningTrackLastMonth', runningtrack_last_month)
                commit('setRunningTrackLastMonthAll', runningtrack_last_month_all)
            });

            return new Promise(async( res, rej ) => {
                firebase.firestore().collection('running_track_month_house').where("company", "==", rootState.authen.user.company).orderBy('date','desc').get()
                .then(function (querySnapshot) {
                    const runningtracks: Array<any> = [];
                    let all_distance = 0;
                    let all_distance16 = 0;
                    querySnapshot.forEach((doc) => {
                        const runningtrack = doc.data()
                        runningtrack.key = doc.id
                        //const date = runningtrack.date.split('-');
                        const enddate = runningtrack.date
                        if(months[enddate] !== undefined){
                            months[enddate].value += runningtrack.distance;
                            all_distance += runningtrack.distance;
                        }
                        if(months16[enddate] !== undefined){
                            months16[enddate].value += runningtrack.distance;
                        }
                        all_distance16 += runningtrack.distance;
                    });
                    for(const x in months) {
                        months[x].value = (months[x].value/1000).toFixed(2)
                    }
                    for(const x in months16) {
                        months16[x].value = (months16[x].value/1000).toFixed(2)
                    }
                    commit('setAllDistance', all_distance16)
                    commit('setAllDistance16', all_distance16)
                    commit('setRunningTrackGraphMonth', months)
                    commit('setRunningTrackGraphMonth16', months16)
                    res();
                });
            });
        }
    },
    getters: {
        houses : ({houses}) => {
            return houses
        },
        housesfilter: ({housesfilter}) => {
            return housesfilter
        },
        runningtrack_day: ({runningtrack_day}) => {
            return runningtrack_day
        },
        runningtrack_day_all: ({runningtrack_day_all}) => {
            return runningtrack_day_all
        },
        runningtrack_week: ({runningtrack_week}) => {
            return runningtrack_week
        },
        runningtrack_week_all: ({runningtrack_week_all}) => {
            return runningtrack_week_all
        },
        runningtrack_month: ({runningtrack_month}) => {
            return runningtrack_month
        },
        runningtrack_month_all: ({runningtrack_month_all}) => {
            return runningtrack_month_all
        },
        runningtrack_last_month: ({runningtrack_last_month}) => {
            return runningtrack_last_month
        },
        runningtrack_last_month_all: ({runningtrack_last_month_all}) => {
            return runningtrack_last_month_all
        },
        distance_all: ({distance_all}) => {
            return (distance_all/1000).toFixed(2)
        },
        distance_all16: ({distance_all16}) => {
            return (distance_all16/1000).toFixed(2)
        },
        runningtrack_graphmonth: ({runningtrack_graphmonth}) => {
            return runningtrack_graphmonth
        },
        runningtrack_graphmonth16: ({runningtrack_graphmonth16}) => {
            return runningtrack_graphmonth16
        },
        members: ({members}) => {
            return members
        },
        activeUsers: ({activeUsers}) => {
            return activeUsers
        },
        allusers: ({allusers}) => {
            return allusers
        },
        getMission: ({mission}) => {
            return mission
        },
        
    }
  }

